module.exports = __webpack_public_path__ + "img/EngineeringOutlined.42238926.svg";